export function stringToBase64(string: string) {
  const binString = Array.from(new TextEncoder().encode(string), (byte) =>
    String.fromCodePoint(byte)
  ).join('')

  return btoa(binString)
}